import "./src/registerConf";

import * as React from "react";
import { GatsbyBrowser } from "gatsby";

import { createOnClientEntry, createOnRouteUpdate } from "@base/gatsbyBrowsers";
import { siteConfig, siteMetadata } from "./src/conf";

import "@fontsource-variable/manrope";
import "@fontsource-variable/inter";
import "./src/global.css";
import "./src/views/landing/styles/global.css";

import { RootWrapper } from "@base/RootWrapper";
import { PageWrapper } from "@base/PageWrapper";

export const onClientEntry: GatsbyBrowser["onClientEntry"] = createOnClientEntry({
  siteConfig,
  siteMetadata,
});

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = createOnRouteUpdate();

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return <RootWrapper>{element}</RootWrapper>;
};

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element }) => {
  return <PageWrapper>{element}</PageWrapper>;
};
